import { render } from "./SumupCheckoutWidgetModal.vue?vue&type=template&id=547fdffa&ts=true"
import script from "./SumupCheckoutWidgetModal.vue?vue&type=script&lang=ts"
export * from "./SumupCheckoutWidgetModal.vue?vue&type=script&lang=ts"

import "./SumupCheckoutWidgetModal.vue?vue&type=style&index=0&id=547fdffa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__